export default __webpack_public_path__ + "static/media/add.5b813f6a.png";